import apiClient from '../http/apiClient';

export default class IngredientAPI {
    static postIngredient = (ingredientData) => apiClient.post('/ingredient', ingredientData);

    static getIngredients = (customer = null) => apiClient.get('/ingredient', {params: {customer}});

    static transferIngredient = (ingredientId, data) => apiClient.put(`/ingredient/${ingredientId}/transfer`, data);
}
